import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"my-2",attrs:{"outlined":""}},[_c(VSubheader,{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.titulo))]),_c(VDivider,{staticClass:"mx-3"}),_c(VSkeletonLoader,{attrs:{"type":"list-item-avatar-two-line@3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }